import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

Swiper.use([Pagination]);

const defaultOptions = {
    slidesPerView: 8,
    slidesPerGroup: 4,
    spaceBetween: 0,
    loop: true,
    pagination: {
        clickable: true,
        type: 'bullets'
    },
    breakpoints: {
        320: {
            slidesPerView: 3,
            slidesPerGroup: 3
        },
        600: {
            slidesPerView: 3,
            slidesPerGroup: 3
        },
        1024: {
            slidesPerView: 6,
            slidesPerGroup: 3
        },
        1280: {
            slidesPerView: 8,
            slidesPerGroup: 4
        }
    }
};

export const userGridOptions = {
    slidesPerView: 5,
    slidesPerGroup: 3,
    spaceBetween: 0,
    loop: true,
    pagination: {
        clickable: true,
        type: 'bullets'
    },
    breakpoints: {
        320: {
            slidesPerView: 2,
            slidesPerGroup: 2
        },
        600: {
            slidesPerView: 2,
            slidesPerGroup: 2
        },
        768: {
            slidesPerView: 4,
            slidesPerGroup: 2
        },
        1280: {
            slidesPerView: 5,
            slidesPerGroup: 3
        }
    }
};

function resolvePagination(grid) {
    return grid.querySelector('.swiper-pagination');
}

export function bindGridSwiper(selector = '.grid.swiper', options = defaultOptions) {
    document.querySelectorAll(selector).forEach(function (grid) {
        if (grid.swiper) return;

        new Swiper(grid, {
            ...options,
            pagination: {
                ...options.pagination,
                el: resolvePagination(grid)
            }
        });
    });
}
